import { useCallback } from 'react'

import { auth, firestore } from 'services/firebase'

const useGetUpdateAllNotifications = () => {
  return useCallback(async () => {
    const { uid } = auth.currentUser
    return firestore
      .collection('users')
      .doc(uid)
      .collection('notifications')
      .orderBy('date', 'desc')
      .where('read', '==', false)
      .get()
      .then((snap) => {
        if (snap.size > 0) {
          return snap.docs.map((doc) => {
            doc.ref.update({ read: true })
          })
        }
      })
  }, []) // eslint-disable-line
}

export default useGetUpdateAllNotifications
